import { cn } from '@/lib/utils';

export const getRatingStyles = (rating: number): string => {
    rating = rating > 5 ? rating / 2 : rating;
    if (rating >= 4.1 && rating <= 5) {
        return 'bg-[#DBFFEA80] text-[#03963F]'; // Excellent
    }
    if (rating >= 3.1 && rating <= 4) {
        return 'bg-[#FFF2DB80] text-[#F0A422]'; // Good
    }
    if (rating >= 2.1 && rating <= 3) {
        return 'bg-[#F08F641F] text-[#F08F64]'; // Average
    }
    return 'bg-[#FFE5E780] text-[#CF0C19]'; // Poor
};

export const getRatingLabel = (rating: number): string => {
    rating = rating > 5 ? rating / 2 : rating;
    if (rating >= 4.1 && rating <= 5) return 'Excellent';
    if (rating >= 3.1 && rating < 4.1) return 'Good';
    if (rating >= 2.1 && rating < 3.1) return 'Average';
    return 'Poor'; // Covers 0 - 2.0
};


export const TableSection: React.FC<{
    title?: string;
    rows: Array<{ criteria: string; rating: number | string; remarks: string }>;
    className?: string;
}> = ({ rows, className }) => (
    <div className={cn("w-full pt-4 sm:pt-0", className)}>
        <div className="border rounded-xl overflow-hidden shadow-sm">
            <table className="hidden w-full border-collapse sm:table">
                <thead className="bg-gray-50">
                    <tr>
                        <th className="p-3 font-dm-sans text-[14px] font-medium leading-[20px] tracking-[0.21px] text-gray-600 text-left border-b w-[20%]">
                            Criteria
                        </th>
                        <th className="p-3 font-dm-sans text-[14px] font-medium leading-[20px] tracking-[0.21px] text-gray-600 text-left border-b w-[5%]">
                            Rating
                        </th>
                        <th className="p-3 font-dm-sans text-[14px] font-medium leading-[20px] tracking-[0.21px] text-gray-600 text-left border-b w-[75%]">
                            Remarks
                        </th>
                    </tr>
                </thead>
                <tbody>
                    {rows.map((row, idx) => (
                        <tr key={idx} className="hover:bg-gray-50">
                            <td className="p-3 border-b text-body2 text-grey-6">
                                {row.criteria}
                            </td>
                            <td className="p-3 border-b text-sm text-gray-600">
                                <span
                                    className={`py-1 px-4 rounded-full font-dm-sans text-base font-normal leading-6 tracking-[0.08px] ${getRatingStyles(
                                        Number(row.rating)
                                    )}`}
                                >
                                    {getRatingLabel(Number(row.rating))}
                                </span>
                            </td>
                            <td className="p-3 border-b text-body2 text-gray-600">
                                {row.remarks}
                            </td>
                        </tr>
                    ))}
                </tbody>
            </table>

            {/* For smaller devices */}
            <div className="block sm:hidden">
                {rows.map((row, idx) => (
                    <div key={idx} className="border-b p-4 hover:bg-gray-50 space-y-2">
                        <div className="flex items-center justify-between">
                            <div className="text-body2 sm:text-sm md:text-sm text-grey-6">
                                {row.criteria}
                            </div>
                            <div
                                className={`py-1 px-4 rounded-full text-base sm:text-sm md:text-sm font-normal leading-6 tracking-[0.08px] max-w-fit ${getRatingStyles(
                                    Number(row.rating)
                                )}`}
                            >
                                {getRatingLabel(Number(row.rating))}
                            </div>
                        </div>
                        <div className="text-sm sm:text-[13px] md:text-[13px] text-gray-600 mt-2">
                            {row.remarks}
                        </div>
                    </div>
                ))}
            </div>
        </div>
    </div>
);